/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';

export default class Override extends Component {
  static defaultProps = {
    min: 0,
    max: 100,
    displayNumber: true,
  };

  render() {
    const min = Number(this.props.min);
    const max = Number(this.props.max);
    let amount = this.props.amount !== undefined ? Number(this.props.amount) : 0;
    const isNegative = amount < 0;
    amount = Math.abs(amount);
    amount = (amount - min) / (max - min);
    // const amountPerc = amount * 100;
    const symbol = this.props.symbol !== undefined ? ' ' + this.props.symbol : ' %';
    /* Chrome will render nothong when start == end, so we leave a tiny little bit out */
    const amountRad = (Math.min(0.9999, Math.max(0, amount)) - 0.00001) * Math.PI * 2;

    const x = Math.sin(amountRad) * 50;
    const y = -Math.cos(amountRad) * 50;

    const long = amountRad > Math.PI ? 1 : 0; // Long/ Short drawing ot the elipse

    /* <!-- Die letzten beiden Zahlen sind die Zielunkte auf dem Außenkreis (absolut)  --> */
    const path = isNegative
      ? 'M0,0 v-50 A 50,50 0 ' + long + ' 0 ' + -x + ' ' + y + ' z'
      : 'M0,0 v-50 A 50,50 0 ' + long + ' 1 ' + x + ' ' + y + ' z';
    let amountStr = '';

    amountStr = this.props.amount.toFixed(1);

    const numchars = amountStr.length + symbol.length;
    if (numchars < 8) {
      amountStr += symbol;
    }

    const startColor = this.props.colorGradient ? this.props.colorGradient.startColor : '#18c5f4';
    const stopColor = this.props.colorGradient ? this.props.colorGradient.stopColor : '#fb3099';
    const gradientId = this.props.colorGradient ? `custom_gradient_${startColor}_${stopColor}` : 'umati_gradient';

    return (
      <svg className="override" viewBox="-50 -50 100 100" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <mask id="innerCircle" x="0" y="0" width="100" height="100">
            <circle className="outer" cx="0" cy="0" r="50" strokeWidth="0" fill="white" />
            <circle className="outer" cx="0" cy="0" r="37" strokeWidth="0" fill="black" />
          </mask>
          <linearGradient id={gradientId} x1="35.35" y1="-35.35" x2="-35.35" y2="35.35" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={startColor} />
            <stop offset="1" stopColor={stopColor} />
          </linearGradient>
        </defs>

        <g mask="url(#innerCircle)">
          <circle className="outer" cx="0" cy="0" r="50" strokeWidth="0" fill="#eaeaea" />
          <path fill={`url(#${gradientId})`} d={path} />
        </g>
        {this.props.displayNumber && numchars >= 8 && (
          <text x="0" y="0" textAnchor="middle" dy="0em" fontSize="16px" fontWeight="bold">
            <tspan textAnchor="middle" x="0%">
              {amountStr}
            </tspan>
            <tspan x="0%" textAnchor="middle" dy="15">
              {symbol}
            </tspan>
          </text>
        )}
        {this.props.displayNumber && numchars < 8 && (
          <text x="0" y="0" textAnchor="middle" dy="0.3em" fontSize="16px" fontWeight="bold">
            {amountStr}
          </text>
        )}
      </svg>
    );
  }
}
